import {
  Charging_mode,
  Charging_power,
  Battery_temp_fast,
  Charging_power_fast,
  Charging_power_normal,
  Battery_temp_normal,
  Charging_Overview_Cycle as ChargingOverviewCycleComponent,
  Charging_Count as ChargingCycleCountComponent,
  Charging_Enrgy_Fast_Normal_cycle as ChargingEnergyDuringFastAndNormalCycle,
  Charging_start_and_end_time as ChargingStartAndEndTimeComponent,
  Charging_soc_start_end as ChargingSocStartEndComponent,
  Cycle_Duration_time as CycleDurationTimeComponent,
  Charging_cycle_current as ChargingCycleCurrentComponent,
  charging_session_count as ChargingSessionCountComponent,
  Charging_cycle_per_charging_session as ChargingCyclePerSessionComponent,
  Charging_session_start_and_end_time as ChargingSessionStartAndEndTimeComponent,
  Charging_session_start_and_end_soc as ChargingSessionStartAndEndSocComponent,
  Charging_session_duration as ChargingSessionDurationComponent,
  System_charging_power_session as SystemChargingPowerSessionComponent,
  System_charging_energy_session as SystemChargingEnergySessionComponent,
  Charger_connected_start_time_and_end_time as ChargerConnectedStartAndEndTimeComponent,
  Charger_connected_start_and_end_soc as ChargerConnectedStartAndEndSocComponent,
  Charger_connected_duration as ChargerConnectedDurationComponent,
  Count_on_trickle_charging_events as CountOnTrickleChargingEventsComponent,
  Charging_power_while_trickle_charging as ChargingPowerWhileTrickleChargingComponent,
  Charging_duration_while_trickle_charging as ChargingDurationWhileTrickleChargingComponent

} from './charging_analysis_kpi';
import ChargingDataDownload from './charging_analysis_kpi/ChargingDataDownload'; // 🔥 Added ChargingDataDownload import
import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Card } from "react-bootstrap";
import charging from "../assets/images/charging_description.png";
import { ManRadioButtonGroup, ManRadioButton, ManText, ManCard } from '@craft-design-system/core-components-react';
import { useGraphContext } from "../GraphContext";
import { Man } from '@mui/icons-material';

const ChargingAnalysis = () => {
  const { graphData } = useGraphContext();
  const [expanded, setExpanded] = useState(null); // 🟢 description open by default

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  const {
    vin_short,
    system_charging_power_kw,
    charging_power_normal_daily_avg_statement,
    batterytemp_charging_fast_daily_avg_statement,
    batterytemp_charging_normal_avg_statement,
    charging_cycle,
    Charging_Overview_Cycle: chargingOverviewData,
    Charging_Count: chargingcyclecount,
    charging_energy_during_fast_and_normal: chargingenergyduringfastandnormal,
    charging_time: chargingstartendtime,
    charging_soc: chargingsoc,
    Cycle_Duration: CycleDurationTimeData,
    Charging_cycle_current: chargingCycleCurrent,
    Charging_session_count: chargingSessionCount,
    Cycle_per_session: chargingCyclePerSession,
    Charging_session_start_and_end_time: chargingSessionStartAndEndTime,
    Charging_session_start_and_end_soc: chargingSessionStartAndEndSoc,
    Charging_session_duration: ChargingSessionDurationData,
    Charging_power_session: chargingPowerSession,
    Charging_energy_session: chargingEnergySession,
    Charger_connected_start_and_end_time: chargerConnectedStartAndEndTime,
    Charger_connected_start_and_end_soc: chargerConnectedStartAndEndSoc,
    Charger_connected_duration: chargerConnectedDuration,
    Count_on_trickle_charging_events: countOnTrickleChargingEvents,
    Charging_power_while_trickle_charging: chargingPowerWhileTrickleChargingData,
    Charging_duration_while_trickle_charging: chargingDurationWhileTrickleChargingData,
    charging_power_during_fast_charging,
    charging_power_during_normal_charging,
    battery_temp_during_fast_charging,
    battery_temp_during_normal_charging,
  } = graphData;

  return (
    <div style={{ backgroundColor: "white", width: "100%" }}>
      {/* 🔥 Added ChargingDataDownload Component */}
      <ChargingDataDownload />

      {/* 🟢 0️⃣ Description Accordion */}
      <Accordion
          expanded={expanded === "description"}
          onChange={handleChange("description")}
          style={{ backgroundColor: "rgb(248, 248, 248)", borderRadius: "5px" }}
        >
          <AccordionSummary aria-controls="description-content" id="description-header">
            <div style={{ display: "flex", alignItems: "center" }}>
              <Typography
                variant="h6"
                style={{ marginLeft: "1.5rem", fontFamily: "MAN EUROPE_Bold", fontSize: "20px" }}
              >
                Description
              </Typography>
              <div style={{ marginLeft: "1rem" }}>
                {expanded === "description" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </div>
            </div>
          </AccordionSummary>

          <AccordionDetails style={{ backgroundColor: "#FFFFFF", color: "#1e2832", padding: "20px" }}>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "flex-start",
                gap: "20px",
              }}
            >
              {/* 🔹 Image on the left */}
              <img
                src={charging}
                alt="Charging Analysis Overview"
                style={{ width: "600px", maxWidth: "100%", height: "auto", borderRadius: "8px" }}
              />

              {/* 🔹 Text on the right */}
              <div style={{ flex: 1, minWidth: "300px" }}>
              <ManText
                variant="body1"
                style={{ fontSize: "16px", color: "#1e2832", lineHeight: "1.6", fontFamily: "Arial, sans-serif" }}
              >
                <span style={{ fontSize: "20px", fontWeight: "bold" }}>Current-based charging logic</span>
                <br />
                <strong>Applies to:</strong> all vehicles providing reliable values on signal <em>"batterycurrent"</em> or <em>"batcurrCBP"</em> over a period of the last 7 calendar days.
                <br /><br />
                <strong>Description:</strong>
                <br />
                For charging events, we distinguish among three time periods: <strong>charging cycle</strong>, <strong>charging session</strong>, and <strong>time charger connected</strong>. We use the signals <em>"highvoltsysmode"</em> and <em>"batterycurrent"/"batcurrCBP"</em> to identify the start and end points of these periods.
                <br /><br />
                - <strong>Time charger connected</strong>: entire duration vehicle is connected to the charger.
                <br />
                - <strong>Charging session</strong>: time during which charging cycles occur (1-n cycles).
                <br />
                - <strong>Charging cycle</strong>: time when current exceeds 10A and SoC increases. Minimum duration is 5 minutes and minimum delta SoC is 2% to exclude trickle charging.
                <br />
                - <strong>Trickle charging</strong>: occurs at high SoC to reach target SoC at end of connection.
                <br /><br />
                <strong>Differentiation among fast and normal charging cycles:</strong>
                <br />
                A matrix defines the transition from normal to fast charging based on SoC (x-axis), battery temperature (y-axis), and battery current (matrix values).
                <br />
                <em>
                  Link to matrix:{" "}
                  <a
                    href="https://manonlineservices.sharepoint.com/:x:/r/sites/BigData/Shared%20Documents/General/060_Projekte/062_Use%20Cases/%5BEDNB%5D%20Electric%20vehicle%20monitoring/Feature%20Requests/Charging%20categorization/fast_charging_matrix.xlsx?d=w47b9f1d823f94bb1b6bda449c4f6011f&csf=1&web=1&e=uEgLVs"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#007bff", textDecoration: "underline" }}
                  >
                    fast_charging_matrix.xlsx
                  </a>
                </em>

                <br /><br />
                <span style={{ fontSize: "20px", fontWeight: "bold" }}>Energylevel-based charging logic</span>
                <br />
                Applies to: all vehicles <strong>not</strong> providing reliable values on signal <em>"batterycurrent"</em> or <em>"batcurrCBP"</em> over the last 7 calendar days.
                <br /><br />
                <strong>Description:</strong>
                <br />
                When current signals are unavailable, we use <em>"highvoltsysmode"</em> and <em>"energylevel"/"energylevelCBP"</em> as backup. Positive gradients in energylevel are treated as charging cycles. Other time periods from current-based logic cannot be identified.
                <br /><br />
                <strong>Differentiation among fast and normal charging cycles:</strong>
                <br />
                Fast charging cycles are defined by charging power per pack exceeding 40kW.
              </ManText>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>



      {/* 🟢 1️⃣ Overview Accordion */}
      <Accordion
        expanded={true} // Always expanded
        style={{ backgroundColor: 'rgb(248, 248, 248)', borderRadius: '5px' }}
      >
        <AccordionSummary aria-controls="overview-content" id="overview-header">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography
              variant="h6"
              style={{ marginLeft: '1.5rem', fontFamily: 'MAN EUROPE_Bold' }}
            >
              Overview
            </Typography>
            <div style={{ marginLeft: '1rem' }}>
              <KeyboardArrowUpIcon /> {/* Always show expanded icon */}
            </div>
          </div>
        </AccordionSummary>

        <AccordionDetails>
          <Card className="firstcard_charging" style={{ width: "100%", height: "auto", position: "relative", overflow: "visible", transition: "height 0.3s ease" }}>
            <ChargingOverviewCycleComponent value={{chargingOverviewData, vin_short}} />
          </Card>
        </AccordionDetails>
      </Accordion>


      {/* 🟡 2️⃣ Cycle Section */}
      <Accordion expanded={expanded === "cycle"} onChange={handleChange("cycle")} style={{ backgroundColor: 'rgb(248, 248, 248)', borderRadius: '5px' }}>
        <AccordionSummary>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="h6" style={{ marginLeft: '1.5rem', fontFamily: 'MAN EUROPE_Bold' }} >Cycle KPIs</Typography>
          <div style={{ marginLeft: '1rem' }}>
          {expanded === "cycle" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </div>
        </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className="card-info_charging">
            <Card className="firstcard_charging"><Charging_mode value={charging_cycle} /></Card>
            <Card className="firstcard_charging"><Charging_power value={{ system_charging_power_kw, vin_short, charging_power_normal_daily_avg_statement }} /></Card>
            <Card className="firstcard_charging"><Battery_temp_fast value={{ battery_temp_during_fast_charging, vin_short, batterytemp_charging_fast_daily_avg_statement }} /></Card>
            <Card className="firstcard_charging"><Battery_temp_normal value={{ battery_temp_during_normal_charging, vin_short, batterytemp_charging_normal_avg_statement }} /></Card>
            <Card className="firstcard_charging"><ChargingCycleCountComponent value={{ chargingcyclecount, vin_short }} /></Card>
            <Card className="firstcard_charging"><ChargingEnergyDuringFastAndNormalCycle value={{ chargingenergyduringfastandnormal, vin_short }} /></Card>
            <Card className="firstcard_charging"><ChargingStartAndEndTimeComponent value={{ chargingstartendtime, vin_short }} /></Card>
            <Card className="firstcard_charging"><CycleDurationTimeComponent value={{ CycleDurationTimeData, vin_short }} /></Card>
            <Card className="firstcard_charging"><ChargingSocStartEndComponent value={{ chargingsoc, vin_short }} /></Card>
            <Card className="firstcard_charging"><ChargingCycleCurrentComponent value={{ chargingCycleCurrent, vin_short }} /></Card>
            <Card className="firstcard_charging"><Charging_power_fast value={charging_power_during_fast_charging} /></Card>
            <Card className="firstcard_charging"><Charging_power_normal value={charging_power_during_normal_charging} /></Card>
          </div>
        </AccordionDetails>
      </Accordion>

      {/* 🔵 3️⃣ Session Section */}
      <Accordion expanded={expanded === "session"} onChange={handleChange("session")} style={{ backgroundColor: 'rgb(248, 248, 248)', borderRadius: '5px' }}>
        <AccordionSummary>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="h6" style={{ marginLeft: '1.5rem', fontFamily: 'MAN EUROPE_Bold' }}>Session KPIs</Typography>
          <div style={{ marginLeft: '1rem' }}>
          {expanded === "session" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </div>
          </div>
        </AccordionSummary>
        
        
        <AccordionDetails>
          <div className="card-info_charging">
            <Card className="firstcard_charging"><ChargingSessionCountComponent value={{ chargingSessionCount, vin_short }} /></Card>
            <Card className="firstcard_charging"><ChargingCyclePerSessionComponent value={{ chargingCyclePerSession, vin_short }} /></Card>
            <Card className="firstcard_charging"><ChargingSessionStartAndEndTimeComponent value={{ chargingSessionStartAndEndTime, vin_short }} /></Card>
            <Card className="firstcard_charging"><ChargingSessionStartAndEndSocComponent value={{ chargingSessionStartAndEndSoc, vin_short }} /></Card>
            <Card className="firstcard_charging"><ChargingSessionDurationComponent value={{ ChargingSessionDurationData, vin_short }} /></Card>
            <Card className="firstcard_charging"><SystemChargingPowerSessionComponent value={{ chargingPowerSession, vin_short }} /></Card>
            <Card className="firstcard_charging"><SystemChargingEnergySessionComponent value={{ chargingEnergySession, vin_short }} /></Card>
          </div>
        </AccordionDetails>
      </Accordion>

      {/* 🟣 4️⃣ Charger Connected + Trickle Section */}
      <Accordion expanded={expanded === "connected"} onChange={handleChange("connected")} style={{ backgroundColor: 'rgb(248, 248, 248)', borderRadius: '5px' }}>
        <AccordionSummary>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="h6" style={{ marginLeft: '1.5rem', fontFamily: 'MAN EUROPE_Bold' }} >Charger Connected & Trickle KPIs</Typography>
          <div style={{ marginLeft: '1rem' }}>
          {expanded === "connected" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className="card-info_charging">
            <Card className="firstcard_charging"><ChargerConnectedStartAndEndTimeComponent value={{ chargerConnectedStartAndEndTime, vin_short }} /></Card>
            <Card className="firstcard_charging"><ChargerConnectedStartAndEndSocComponent value={{ chargerConnectedStartAndEndSoc, vin_short }} /></Card>
            <Card className="firstcard_charging"><ChargerConnectedDurationComponent value={{ chargerConnectedDuration, vin_short }} /></Card>
            <Card className="firstcard_charging"><CountOnTrickleChargingEventsComponent value={{ countOnTrickleChargingEvents, vin_short }} /></Card>
            <Card className="firstcard_charging"><ChargingPowerWhileTrickleChargingComponent value={{ chargingPowerWhileTrickleChargingData, vin_short }} /></Card>
            <Card className="firstcard_charging"><ChargingDurationWhileTrickleChargingComponent value={{ chargingDurationWhileTrickleChargingData, vin_short }} /></Card>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default ChargingAnalysis;